import React, { useState, useEffect } from "react";

import RequestHandler from "util/RequestHandler";
import { ColumnHelper, RowHelper } from "util/TableHelper";
import PosCollectionTransactionTableFilter from "../Filters/PosCollectionTransactionTableFilter";
import B2bPosCollectionSendReceiptForm from "../Forms/B2bPosCollectionSendReceiptForm";
import moment from "moment";
import config from "../../util/ApiforContext";
import {
  Table,
  Empty,
  Col,
  Row,
  Tooltip,
  Modal,
  Popconfirm,
  message
} from "antd";
import {
  BarsOutlined,
  CheckCircleOutlined,
  ClockCircleOutlined,
  CloseCircleOutlined,
  FilePdfOutlined,
  DeleteOutlined,
  WarningOutlined,
  FileExcelOutlined,
} from "@ant-design/icons";
import { odata } from "../Filters/Helper";
import Iframe from "react-iframe";
import PosCollectionTransactionRefundModal from "./PosCollectionTransactionRefundModal";

const userId = localStorage.getItem("userId");
const PosCollectionTransaction = (props) => {
  const [tableData, setTableData] = useState({
    data: [],
    total: 0,
    loading: true,
  });
  const [receiptModalVisible, setReceiptModalVisible] = useState();
  const [isReceiptMailSend, setIsReceiptMailSend] = useState();

  const [tableDataQueryOptions, setTableDataQueryOptions] = useState({
    skip: 0,
    take: 15,
    current: 1,
    filter: "",
  });
  const [sendReceiptModal, setSendReceiptModal] = useState({
    visible: false,
    data: null,
  });
  const [order, setOrder] = useState("");
  const [isAdmin, setIsAdmin] = useState(false);
  const [canPosCancelBankIdList, setCanPosCancelBankIdList] = useState([]);
  const [canPosRefundBankIdList, setCanPosRefundBankIdList] = useState([]);
  const [pdfUrl, setPdfUrl] = useState("");
  const [allowCancel, setAllowCancel] = useState(false);
  const [
    posCollectionTransactionRefundModal,
    setPosCollectionTransactionRefundModal,
  ] = useState({
    visible: false,
    data: null,
  });
  const [useAdditionalInformation, setUseAdditionalInformation] =
    useState(false);

  useEffect(() => {
    RequestHandler.get("/TenantParameter/GetByTenant").then((response) => {
      if (response) {
        setUseAdditionalInformation(
          response.isPosTransactionUseAdditionalField
        );
      }
    });
  }, []);

  useEffect(() => getTableData(), [order, tableDataQueryOptions]);

  const getFilterQuery = () => {
    const { filter } = tableDataQueryOptions;

    const conditions = [];
    let query = "";

    if (filter) {
      conditions.push(filter);
    }

    if (conditions.length !== 0) {
      query = "&$filter=" + conditions.join(" and ");
    }
    return query;
  };

  const getTableData = () => {
    setTableData({
      ...tableData,
      loading: true,
    });

    RequestHandler.get(`/TenantUserParameter/GetDigitParameter`).then(
      (response) => {
        if (response.success) {
          setIsReceiptMailSend(response.data.isReceiptMailSend);
        }
      }
    );

    RequestHandler.get(`/user/IsAdmin?userId=${userId}`).then((response) => {
      setIsAdmin(response);
    });
    const { skip, take } = tableDataQueryOptions;

    RequestHandler.get(
      `/PosCollectionTransaction?$count=true${getFilterQuery()}${order}&$skip=${skip}&$top=${take}`
    ).then((response) => {
      if (Array.isArray(response.value)) {
        setTableData({
          data: response.value,
          total: response["@odata.count"],
          loading: false,
        });
      }
    });
    RequestHandler.get(`/Bank`).then((response) => {
      if (Array.isArray(response.value)) {
        let supportPosCancelList = [];
        let supportPosRefundList = [];
        response.value.map((item) => {
          if (item.isSupportPosCancel) {
            supportPosCancelList.push(item.id);
          }
          if (item.isSupportPosRefund) {
            supportPosRefundList.push(item.id);
          }
        });
        setCanPosCancelBankIdList(supportPosCancelList);
        setCanPosRefundBankIdList(supportPosRefundList);
      }
    });

    RequestHandler.get("/TenantUser/IsAllowB2bCancel").then((response) => {
      setAllowCancel(response);
    });
  };

  const paging = (p, filters, sorter) => {
    let order = "";
    if (sorter.columnKey && sorter.order) {
      order =
        "&" +
        (sorter.order === "ascend"
          ? odata.orderBy(sorter.columnKey)
          : odata.orderByDesc(sorter.columnKey));
    }
    setOrder(order);
    setTableDataQueryOptions((prevState) => {
      return {
        ...prevState,
        skip: (p.current - 1) * prevState.take,
        take: p.pageSize,
        current: p.current,
      };
    });
  };

  const onClearTableFilter = () => {
    setTableDataQueryOptions({
      skip: 0,
      current: 1,
      take: tableDataQueryOptions.take,
      filter: "",
    });
  };

  const setCancelPosTransaction = (row) => {
    if (row.isCanRefund) {
      setPosCollectionTransactionRefundModal({
        data: row,
        visible: true,
      });
      return;
    }
    var processType = row.isCanCancel ? "İptal" : "İade";
    const hideMessage = message.loading(
      processType + " işlemi başlatıldı...",
      0
    );
    RequestHandler.post(
      `/PosCollection/CancelPosProcess`,
      {
        id: row.id,
      },
      true
    ).then((response) => {
      if (response.success) {
        if(row.cancelRefundRequest == 0)  {
          refundRequestChangeStatus(row.id, 1);
        }
        
        setTimeout(() => {
          hideMessage();
          window.location.reload();
        }, 2000);
      }
    });
  };
  


  const refundRequestChangeStatus = (id, status) => {
    RequestHandler.post(
      `/PosCollectionTransaction/ChangeRefundRequestStatus/${id}?status=${status}`, null, false
    ).then((response) => {
      getTableData();
    });
  }

  const onFinishTableFilter = (query) => {
    setTableDataQueryOptions((prevState) => {
      return { skip: 0, current: 1, take: prevState.take, filter: query };
    });
  };

  const onClickSendReceipt = (id) => {
    setSendReceiptModal({ visible: true, data: { id } });
  };
  const onClickShowReceipt = (id) => {
    const hideMessage = message.loading("Pdf açılyor...", 0);
    RequestHandler.get(
      `/PosCollectionTransaction/DownloadPdfReceiptColumnsWithDoc?id=${id}`,
      undefined,
      { rawResponse: true }
    ).then((response) => {
      hideMessage();
      setPdfUrl(response.data);
      setTimeout(() => {
        setReceiptModalVisible(true);
      }, 1000);
    });
  };
  const handleOkReceipt = () => {
    setPdfUrl("");
    setReceiptModalVisible(false);
  };
  const handleCancelReceipt = () => {
    setPdfUrl("");
    setReceiptModalVisible(false);
  };
  const onClickExportExcel = () => {
    const hideMessage = message.loading("Excel indiriliyor...", 0);

    RequestHandler.post(
      `/PosCollectionTransaction/ExportExcel`,
      {
        query: getFilterQuery(),
      },
      false
    ).then((response) => {
      hideMessage();

      if (response) {
        window.open(
          `${
            config.apiUrl
          }/PosCollectionTransaction/DownloadExcel?fileName=${response}&t=${RequestHandler.getToken()}`
        );
      }
    });
  };

  const columns = [
    {
      title: "Banka",
      dataIndex: "bankLogo",
      width: 150,
      render: (text) => <img src={text}></img>,
    },
    {
      title: "Cari Kodu",
      dataIndex: "firmCode",
      render: (data) => (data ? data : "-"),
    },
    {
      title: "İşlemi Yapan",
      dataIndex: "addUserName",
    },
    {
      title: "Ünvan",
      dataIndex: "firmName",
      render: (data, row) => (row.firmCode ? data : row.customerInformation),
    },
    {
      title: "Tahsilat Tutarı",
      dataIndex: "amount",
      key: "amount",
      sorter: true,
      render: ColumnHelper.renderDecimal,
    },
    {
      title: "Para Birimi",
      dataIndex: "currencyCode",
    },
    {
      title: "Taksit Sayısı",
      dataIndex: "installmentCount",
    },
    {
      title: "İşlem Tarihi",
      dataIndex: "addDate",
      key: "addDate",
      sorter: true,
      align: "center",
      render: (data) => moment(data).format("DD.MM.YYYY HH:mm"),
    },
    {
      title: "Onay Kodu",
      dataIndex: "authCode",
    },

    {
      title: "İşlem Sonucu",
      dataIndex: "success",
      align: "center",
      render: (data, row) => {
        if (row.isCancel || row.isRefund || row.isPartialRefund) {
          return (
            <Tooltip title={row.message}>
              <WarningOutlined
                style={
                  row.isCancel
                    ? { color: "red", fontSize: "130%" }
                    : { color: "orange", fontSize: "130%" }
                }
              />
            </Tooltip>
          );
        } else {
          if (data === null) {
            return (
              <Tooltip title={row.message}>
                <ClockCircleOutlined
                  style={{ color: "orange", fontSize: "130%" }}
                />
              </Tooltip>
            );
          }
          return data ? (
            <Tooltip title={row.message}>
              <CheckCircleOutlined
                style={{ color: "green", fontSize: "130%" }}
              />
            </Tooltip>
          ) : (
            <Tooltip title={row.message}>
              <CloseCircleOutlined style={{ color: "red", fontSize: "130%" }} />
            </Tooltip>
          );
        }
      },
    },
    allowCancel
      ? {
          title: "İptal/İade",
          dataIndex: "orderId",
          align: "center",
          render: (data, row) => {
            if (
              (row.isCanCancel || row.isCanRefund) &&
              row.success &&
              (canPosCancelBankIdList.includes(row.bankId) ||
                canPosRefundBankIdList.includes(row.bankId))
            ) {
              if (row.orderId !== null) {
                return (
                  <Popconfirm
                    title={
                      row.cancelRefundRequest == 0 ? "İşlemin İptal/İade talebi gelmiştir, işlemi İptal/İade etmek istiyor musunuz?" :
                      row.isCanCancel
                        ? "İptal etmek istiyor musunuz?"
                        : "Bu işlem gün içinde gerçekleşmediğinden iade işlemi yapılacaktır. Onaylıyor musunuz?"
                    }
                    okText="Evet"
                    cancelText="Hayır"
                    onConfirm={() => setCancelPosTransaction(row)}
                    onCancel={() => {
                       if(row.cancelRefundRequest == 0) {
                        refundRequestChangeStatus(row.id, 2);
                       }
                    }}
                  >
                    <DeleteOutlined
                      style={{ color: "red", fontSize: "130%" }}
                    />
                  </Popconfirm>
                );
              } else {
                return (
                  <Tooltip title={"Bu ödeme iptal edilemez."}>
                    <DeleteOutlined style={{ fontSize: "130%" }} disabled />
                  </Tooltip>
                );
              }
            } else if (!row.isCanCancel && !row.isCanRefund) {
              return (
                <Tooltip
                  title={
                    "Ödeme tarihinden itibaren 1 gün geçen ödemeler iptal edilemez."
                  }
                >
                  <DeleteOutlined
                    style={{ fontSize: "130%", opacity: "0.3" }}
                    disabled
                  />
                </Tooltip>
              );
            } else {
              return (
                <Tooltip title={"Bu ödeme iptal edilemez."}>
                  <DeleteOutlined
                    style={{ fontSize: "130%", opacity: "0.3" }}
                    disabled
                  />
                </Tooltip>
              );
            }
          },
        }
      : {},
    {
      title: "Erp Kodu",
      dataIndex: "documentNumber",
    },
    {
      title: "Dekont",
      dataIndex: "id",
      align: "center",
      render: (data, row) => {
        const receiptAvailableBankIds = [889, 893];
        if (row.success && receiptAvailableBankIds.includes(row.bankId)) {
          return (
            <a onClick={() => onClickSendReceipt(data)}>
              <FilePdfOutlined style={{ color: "black", fontSize: "130%" }} />
            </a>
          );
        } else if (row.success && !isReceiptMailSend) {
          return (
            <a onClick={() => onClickShowReceipt(data)}>
              <FilePdfOutlined style={{ color: "black", fontSize: "130%" }} />
            </a>
          );
        } else if (row.success && isReceiptMailSend) {
          return (
            <a onClick={() => onClickSendReceipt(data)}>
              <FilePdfOutlined style={{ color: "black", fontSize: "130%" }} />
            </a>
          );
        }

        return null;
      },
    },
  ];

  const renderDetailString = (text) => (text ? text : "-");
  const detailColumns = [
    {
      title: "E-posta",
      dataIndex: "customerEmail",
      render: renderDetailString,
    },
    {
      title: "Cep Telefonu",
      dataIndex: "mobilePhone",
      render: renderDetailString,
    },
    {
      title: "Açıklama",
      dataIndex: "description",
      render: renderDetailString,
    },
    {
      title: "İade Tutarı",
      dataIndex: "refundAmount",
      render: ColumnHelper.renderDecimal,
    },
  ];

  if (useAdditionalInformation) {
    detailColumns.push(
      {
        title: "Sözleşme No",
        dataIndex: "contractNumber",
        render: renderDetailString,
      },
      {
        title: "Ek Alan",
        dataIndex: "memberNumber",
        render: renderDetailString,
      },
      {
        title: "TCKN",
        dataIndex: "tckn",
        render: renderDetailString,
      },
      {
        title: "Şube Adı/Kodu",
        dataIndex: "branchCode",
        render: renderDetailString,
      }
    );
  }

  return (
    <>
      <Row>
        <Col xs={24} md={12} lg={16}>
          <p style={{ fontSize: "120%", marginTop: -5 }}>
            <BarsOutlined /> POS TAHSİLATLARI
          </p>
        </Col>
        <Col xs={24} md={12} lg={8} style={{ textAlign: "right" }}>
          <Tooltip title="Excel İndir">
            <a
              style={{
                color: "green",
                fontSize: "180%",
                marginRight: 30,
              }}
              onClick={onClickExportExcel}
            >
              <FileExcelOutlined />
            </a>
          </Tooltip>
        </Col>
      </Row>

      <PosCollectionTransactionTableFilter
        onClearFilter={onClearTableFilter}
        onFinishFilter={onFinishTableFilter}
        style={{ marginTop: 12, marginBottom: 12 }}
      />

      <Row id="tableArea">
        <Col span={24}>
          <Table
            columns={columns}
            expandable={{
              expandedRowRender: (row) =>
                RowHelper.renderRowDetail({
                  data: row,
                  columns: detailColumns,
                }),
            }}
            locale={{
              emptyText: (
                <Empty
                  image={Empty.PRESENTED_IMAGE_SIMPLE}
                  description="Veri Yok"
                />
              ),
            }}
            style={{ overflowX: "auto", maxHeight: "100%", width: "100%" }}
            rowKey="id"
            filterable={true}
            sortable={true}
            pageable={true}
            onChange={paging}
            pagination={{
              defaultPageSize: tableDataQueryOptions.take,
              pageSizeOptions: ["15", "25", "50", "100"],
              total: tableData.total,
              current: tableDataQueryOptions.current,
            }}
            dataSource={tableData.data}
            loading={tableData.loading}
            size="small"
            rowClassName={(record,index) => record.cancelRefundRequest == 0 ? 'table-row-yellow': 'table-row-default'}
          />
        </Col>
      </Row>

      <Modal
        id="sendReceiptModal"
        centered
        visible={sendReceiptModal.visible}
        onCancel={() => setSendReceiptModal({ visible: false, data: null })}
        footer={null}
      >
        <B2bPosCollectionSendReceiptForm
          data={sendReceiptModal.data}
          onFinish={() => setSendReceiptModal({ visible: false, data: null })}
        />
      </Modal>

      <Modal
        title="Dekont"
        width={1200}
        style={{ height: 550 }}
        visible={receiptModalVisible}
        onOk={handleOkReceipt}
        onCancel={handleCancelReceipt}
        footer={null}
      >
        <Iframe
          url={pdfUrl}
          width="100%"
          height="550px"
          id="myId"
          className="myClassname"
          display="initial"
          position="relative"
        />
      </Modal>

      <Modal
        id="posCollectionRefundModal"
        centered
        width={500}
        visible={posCollectionTransactionRefundModal.visible}
        onCancel={() =>
          setPosCollectionTransactionRefundModal({ visible: false, data: null })
        }
        footer={null}
        title={"İade Talebi"}
        destroyOnClose={true}
      >
        <PosCollectionTransactionRefundModal
          data={posCollectionTransactionRefundModal.data}
          onSuccess={() => {

            var data = posCollectionTransactionRefundModal.data;

            setPosCollectionTransactionRefundModal({
              visible: false,
              data: null,
            });

            if(data.cancelRefundRequest === 0) {
              refundRequestChangeStatus(data.id, 1);
            }
            else {
              getTableData();
            }
         
         
          }}
        />
      </Modal>
    </>
  );
};

export default PosCollectionTransaction;
